// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"49b1bf7b4ef005e9d859","25825":"ff4a0d210f19783a92e4","80020":"68ade150804af6c27187"}[chunkId] + ".css";
};